import script from "./CreateRepoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateRepoDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateRepoDialog.vue?vue&type=style&index=0&id=34bda6e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34bda6e0"]])

export default __exports__